import { Box, Icon, Popover } from '@bechtel/gds';
import { noop } from 'lodash';
import { FC, useRef, useState } from 'react';
import { IconButtonStyled, MultiLingualText } from '~/components';
//@ts-ignore images ignore

interface ExpandCollapseActionProps {
  isCollapsed: boolean;
  onExpandCollapse: () => void;
}
export const ExpandCollapseAction: FC<ExpandCollapseActionProps> = ({ isCollapsed, onExpandCollapse = noop }) => {
  const expandCollapseRef = useRef(null);
  const [showMessage, setShowMessage] = useState(false);
  return (
    <>
      <div ref={expandCollapseRef}>
        <Box
          onMouseOver={() => setShowMessage(true)}
          onMouseLeave={() => setShowMessage(false)}
          onClick={onExpandCollapse}
        >
          <IconButtonStyled>
            <Icon icon={isCollapsed ? 'chevron-up' : 'chevron-down'} iconStyle="regular" fillColor="primary.900" />
          </IconButtonStyled>
        </Box>
      </div>
      <Popover
        triggerComponentRef={expandCollapseRef}
        showPopper={showMessage}
        customStyle={{ backgroundColor: 'black', color: 'white', zIndex: 1 }}
        placement="bottom"
      >
        <Box py={{ sm: '300' }} px={{ sm: '400' }} css={{ textAlign: 'center' }}>
          <MultiLingualText size="300" color="white" family="openSansCondensed">
            {isCollapsed ? 'Expand' : 'Collapse'}
          </MultiLingualText>
        </Box>
      </Popover>
    </>
  );
};
